import { render, staticRenderFns } from "./insuranceSucceed.vue?vue&type=template&id=5afa9fb8&scoped=true&"
import script from "./insuranceSucceed.vue?vue&type=script&lang=js&"
export * from "./insuranceSucceed.vue?vue&type=script&lang=js&"
import style0 from "./insuranceSucceed.vue?vue&type=style&index=0&id=5afa9fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa9fb8",
  null
  
)

export default component.exports